module.exports = __webpack_public_path__ + "kh.svg?af2e77f02d7a44c3c2222d61350d884e";